export class DataPrint {  
    formPrint: any;
    dataPrints: any;
}